"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isActiveParcel = function isActiveParcel(parcel) {
  return parcel.quantity !== 0;
};

var parcelsAdapter = function parcelsAdapter(parcels) {
  return parcels.filter(isActiveParcel);
};

var _default = parcelsAdapter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/adapters/parcelsAdapter.js
// module id = 728
// module chunks = 5 6